import { render, staticRenderFns } from "./TaxTable.vue?vue&type=template&id=7f8617a3&"
import script from "./TaxTable.vue?vue&type=script&lang=js&"
export * from "./TaxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports